var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wb-question',{attrs:{"question":_vm.$me,"isDisabled":true}},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$t("WebInterviewUI.QuestionUnsupported")))])])])}
var staticRenderFns = []

export { render, staticRenderFns }